<app-page-content>
<app-doenkids-menu-bar menuBar [loading]="isSearching$ | async">
  <div left>
    @if (!(showMobileSearchBar$ | async)) {
      <app-activity-search-bar [query]="currentSearchParams?.query" [contentLanguage]="currentSearchParams?.language" (searched)="doSearch($event)"></app-activity-search-bar>
    }
  </div>
  <div right>
    <form class="form-wrapper">
      @if (!(isReader$ | async)) {
        <mat-checkbox class="top-checkbox" [formControl]="selectActivitiesControl"> {{ 'activity_search.collect_activities' | translate }}</mat-checkbox>
      }
      <app-responsive-toolbar-content
        class="status-filter-container"
        icon="filter_list"
        [isOpen]="toolBarContentOpen | async"
        tooltip="activity_search.responsive_toolbar.tooltip"
        (toolBarMenuOpen)="updateToolbarMenuOpen($event)"
        >
        <ng-template #content>
          <app-activity-status-filters
            (change)="updateStateFilters($event)"
            [activityStatusFilterForm]="activityStatusFiltersControl"
            [sortOptionControl]="sortOptionControl"
            >
          </app-activity-status-filters>
        </ng-template>
      </app-responsive-toolbar-content>
    </form>
  </div>
</app-doenkids-menu-bar>
<div content>
@if (showMobileSearchBar$ | async) {
  <div class="mobile-search-bar">
    <app-activity-search-bar [query]="currentSearchParams?.query" [contentLanguage]="currentSearchParams?.language" (searched)="doSearch($event)"></app-activity-search-bar>
  </div>
}
<div class="page-container" #pageContainer>
  <app-split-page
    #splitPage
    [leftLabel]="'activity_search.tab.filters' | translate"
    [rightLabel]="'activity_search.tab.results' | translate"
    [activeTab]="1"
    [leftWidth]="23"
    [independentScroll]="true"
    [scrollEventsRight]="true"
    [hide]="hideAggregations$ | async"
    sideToHide="left"
    whatToHide="side"
    (scrollEndRight)="onScrollEnd()"
    (selectedTabChange)="tabChange($event)"
    >
    <ng-template #left>
      @if (aggregations$ | async) {
        <div class="aggregations">
          <app-search-aggregations
            [aggregationLabels]="aggregationLabels | async"
            [aggregationData]="aggregations$ | async"
            [formControl]="aggregationControl">
          </app-search-aggregations>
        </div>
      }
    </ng-template>

    <ng-template #right>
      <div class="results-panel">
        <div class="results-header" #resultsHeader>
          <div class="results-header-wrapper" [class.hasFilters]="containsAggregations$ | async">
            <mat-toolbar class="mat-toolbar-doenkids">
              @if (!(isMobile$ | async) && !(hideAggregations$ | async)) {
                <button
                  mat-icon-button
                  [matTooltip]="'activity_search.tooltip.left' | translate"
                  (click)="toggleAggregations()"
                  >
                  <mat-icon>chevron_left</mat-icon>
                </button>
              }
              @if (!(isMobile$ | async) && hideAggregations$ | async) {
                <button
                  mat-icon-button
                  [matTooltip]="'activity_search.tooltip.right' | translate"
                  (click)="toggleAggregations()"
                  >
                  <mat-icon>chevron_right</mat-icon>
                </button>
              }
              @if (activitySearchMetadata$ | async; as metaData) {
                <div class="result-amount">
                  @if (metaData?.total > 0) {
                    <span
                    [innerHTML]="'activity_search.search_metadata' | translate: {
                    resultCount: metaData?.total,
                  }"
                      >
                    </span>
                  }
                  @for (suggestion of searchSuggestions$ | async; track suggestion) {
                    <span class="did-you-mean">
                      @if (suggestion.options && suggestion.options.length > 0) {
                        <span>{{ 'activity_search.suggestions' | translate }}&nbsp;</span
                          >@for (option of suggestion.options; track option) {
                          <a href="#" (click)="trySuggestion(option.text, $event)" [innerHTML]="option.highlighted"></a>
                        }
                        <span>?</span>
                      }
                    </span>
                  }
                </div>
              }
              <div class="spacer"></div>
            </mat-toolbar>
            @if (containsAggregations$ | async) {
              <mat-toolbar-row class="mat-toolbar-doenkids mat-toolbar-chips">
                <app-search-chips
                  class="search-chips"
                  [aggregationLabels]="aggregationLabels | async"
                  (onRemoveAll)="removeAllFilters()"
                  (onRemove)="removeFilter($event)"
                  [aggregationData]="aggregations$ | async"
                  [selection]="aggregationControl.value"
                  >
                </app-search-chips>
              </mat-toolbar-row>
            }
          </div>
        </div>

        <div class="search-results">
          @if (searchResults$ | async; as results) {
            <div class="body-container animated fadeIn">
              @if (results.length > 0) {
                <ngx-masonry
                  #regularMasonry
                  [options]="{ gutter: 25, transitionDuration: '0s', fitWidth: true, horizontalOrder: true }"
                  >
                  @for (activity of results; track activity.id) {
                    <ngxMasonryItem class="masonry-item">
                      <app-activity-card
                        (loaded)="imageLoaded()"
                        (click)="activityClicked(activity)"
                        [class.selected]="(isSelectingActivties$ | async) && activityIsSelected(activity)"
                        [class.archived]="activityStatusFiltersControl.value?.showActivities === 'Archived'"
                        [activity]="activity"
                        >
                      </app-activity-card>
                    </ngxMasonryItem>
                  }
                </ngx-masonry>
              }
            </div>
            @if (results.length === 0) {
              <div>{{ 'activity_search.no_results' | translate }}</div>
            }
          }
        </div>
      </div>
    </ng-template>
  </app-split-page>
</div>
</div>
<div fixed>
@if (!(hasDisableActivityCreatePermission$ | async) && !(isReader$ | async)) {
  <button
    mat-fab
    class="doenkids-fab add-activity"
    color="primary"
    [disabled]="!(hasSelectedOUWritePermission$ | async)"
    (click)="createNew()"
    >
    <mat-icon [aria-label]="'activity.create_new' | translate">add</mat-icon>
  </button>
}
@if ((isSelectingActivties$ | async) && !(isReader$ | async)) {
  <app-selected-activities></app-selected-activities>
}
<router-outlet></router-outlet>
</div>
</app-page-content>
